import { render, staticRenderFns } from "./JdsBadge.vue?vue&type=template&id=6f7b2f94"
import script from "./JdsBadge.vue?vue&type=script&lang=js"
export * from "./JdsBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports